import React, { useState, useEffect } from 'react'
import { AuthContext, useAuthentication, getLocalToken } from 'react-u5auth'
import { LoggingInSpinner } from '../presentation/spinners'
import fetchPonyfill from 'fetch-ponyfill'
import { ForbiddenMessage } from '../presentation/alerts'
const { fetch } = fetchPonyfill()

const clientId = process.env.REACT_APP_AUTH_CLIENT_ID
const authProvider = process.env.REACT_APP_AUTH_PROVIDER || 'https://login.voteda.org'

export const AuthProvider = ({ children }) => (
  <AuthContext clientId={clientId} provider={authProvider}>
    {children}
  </AuthContext>
)

export const Authenticated = ({ children }) => {
  const { authenticated } = useAuthentication()
  return authenticated ? children : <LoggingInSpinner />
}

export const Authorized = ({ children }) => {
  const [authState, setAuthState] = useState('checking')
  const token = getLocalToken()

  useEffect(() => {
    let cancelled = false

    const testAuth = async () => {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/test`, { headers: { Authorization: `Bearer ${token}` } })
      if (cancelled) return
      if (response.ok) {
        setAuthState('ok')
      } else {
        setAuthState('forbidden')
      }
    }

    testAuth()

    return () => { cancelled = true }
  }, [token])

  if (authState === 'ok') {
    return children
  } else if (authState === 'checking') {
    return <LoggingInSpinner />
  } else {
    return <ForbiddenMessage forbiddenItem='this site' />
  }
}
